import React from 'react';
import './Footer.css';
import {
  FaMapMarkerAlt, FaPhone, FaEnvelope,
  FaWhatsapp
} from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="brand-header">
            <h3>Project Power By CW</h3>
          </div>
          <p>Delivering custom engineering solutions and system integration to enhance precision, efficiency, and automation.</p>
          <div className="social-links">
            <a href="https://api.whatsapp.com/send/?phone=60162865881&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaWhatsapp/>
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h3>Contact</h3>
          <div className="">
            <p className="contact-item">
              <span className="icon-wrapper">
                <FaMapMarkerAlt />
              </span>
              70-1, Jalan PJS 11/7, Bandar Sunway
            </p>
            <p className="contact-item">
              <span className="icon-wrapper">
                <FaPhone />
              </span>
              +60 16-286 5881
            </p>
            <p className="contact-item">
              <span className="icon-wrapper">
                <FaEnvelope />
              </span>
              sales@projectpowerbycw.com
            </p>
          </div>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="quick-links">
            <li><a href="/about">About Us</a></li>
            <li><a href="/projects">Projects</a></li>
            <li><a href="/inquiry">Contact</a></li>
            <li><a href="https://wa.me/60162865881" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Legal</h3>
          <ul className="quick-links">
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms of Service</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Project Power By CW. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer; 